<template>

    <b-modal
        id="sections-translations-modal"
        :title="t.__('Tłumacz sekcje') + ' ' + elementTypeText"
        :ok-title="t.__('Zapisz')"
        :cancel-title="t.__('Anuluj')"
        ok-variant="success"
        no-close-on-backdrop
        @ok="modalHandleOk"
        @hidden="modalHandleHide">

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="base-language">{{ t.__('Język bazowy') }}</label>
                    <select class="form-control" id="base-language" v-model="baseLanguage">
                        <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                        <option v-for="languagesOption in languagesOptions" :value="languagesOption.id">{{ languagesOption.text }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="translated-language">{{ t.__('Język tłumaczony') }}</label>
                    <select class="form-control" id="translated-language" v-model="translatedLanguage">
                        <option :value="null" disabled selected>{{ t.__('Wybierz') }}</option>
                        <option v-for="languagesOption in languagesOptions" :value="languagesOption.id">{{ languagesOption.text }}</option>
                    </select>
                </div>
            </div>
        </div>

        <hr class="mb-4">

        <div class="row">
            <div class="col">

                <form>

                    <div class="input-group input-group-sm mb-1" v-for="(translation, index) in baseLanguageTranslations" :key="index">
                        <input type="text" class="form-control" :placeholder="t.__('Nazwa sekcji')" :value="translation.name" readonly>
                        <div class="input-group-append">
                            <a href="#" class="btn btn-sm btn-primary" @click="copy(index)"><i class="fa fa-arrow-right mr-0" aria-hidden="true"></i></a>
                        </div>
                    </div>

                </form>

            </div>
            <div class="col">
                <form @submit.prevent="submitForm" @keydown="form.errors.clear($event.target.name)" ref="element-form">

                    <div class="form-group form-group-sm mb-1" v-for="(translation, index) in form.translations" :key="index">
                        <input type="text" class="form-control form-control-sm" :placeholder="t.__('Nazwa sekcji')" v-model="form.translations[index].name">
                    </div>

                </form>
            </div>
        </div>



    </b-modal>

</template>

<script>

    export default {

        name: 'MarketingResourcesSectionsModal',

        props: [
            'languages',
            'baseLanguageInput'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                elementType: null,
                elementTypeText: null,
                languagesOptions: [],
                baseLanguage: this.baseLanguageInput.code,
                translatedLanguage: 'en',
                baseLanguageTranslations: [],
                form: new Vue.prototype.Form({
                    translations: []
                })
            }
        },

        watch: {
            baseLanguage: function () {
                localStorage.setItem('marketingResourcesLang', this.baseLanguage);
                this.loadBaseLanguage();
            },
            translatedLanguage: function () {
                localStorage.setItem('marketingResourcesTranslatedLang', this.translatedLanguage);
                this.loadTranslatedLanguage();
            }
        },

        beforeMount() {

            this.languages.forEach(language => {
                this.languagesOptions.push({
                    text: language.name,
                    id: language.code
                });
            });

        },

        mounted() {

            this.eventHub.$on('marketing-resources-sections-translate', (elementType) => {
                if (![null, undefined, 'null', 'undefined'].includes(localStorage.getItem('marketingResourcesLang'))) {
                    this.baseLanguage = localStorage.getItem('marketingResourcesLang');
                } else {
                    this.baseLanguage = 'pl';
                }
                if (![null, undefined, 'null', 'undefined'].includes(localStorage.getItem('marketingResourcesTranslatedLang'))) {
                    this.translatedLanguage = localStorage.getItem('marketingResourcesTranslatedLang');
                } else {
                    this.translatedLanguage = 'en';
                }
                this.elementType = elementType;
                if (this.elementType === 'area') {
                    this.elementTypeText = 'obszaru'
                } else if (this.elementType === 'package') {
                    this.elementTypeText = 'pakietu'
                } else if (this.elementType === 'set') {
                    this.elementTypeText = 'zestawu'
                } else if (this.elementType === 'game') {
                    this.elementTypeText = 'gry'
                }
                this.loadBaseLanguage();
                this.loadTranslatedLanguage();
            });

        },

        methods: {

            loadBaseLanguage() {
                this.eventHub.$emit('processing-start');
                axios.get(route('game::marketing-resources.get-sections-translations', {elementType: this.elementType, language: this.baseLanguage}))
                    .then(response => {
                        this.baseLanguageTranslations = response.data.data.translations;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('sections-translations-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            },

            loadTranslatedLanguage() {
                this.eventHub.$emit('processing-start');
                axios.get(route('game::marketing-resources.get-sections-translations', {elementType: this.elementType, language: this.translatedLanguage}))
                    .then(response => {
                        this.form = new Vue.prototype.Form({
                            translations: response.data.data.translations.map(translation => {
                                return {
                                    section_id: translation.section_id,
                                    name: translation.name
                                }
                            })
                        });
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('sections-translations-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak.'), 'error');
                    });
            },

            copy(index) {
                this.form.translations[index].name = this.baseLanguageTranslations[index].name;
            },

            modalHandleOk(event) {
                event.preventDefault();
                this.submitForm();
            },

            modalHandleHide() {
                this.elementType = null;
                this.elementTypeText = null;
                this.form = new Vue.prototype.Form({
                    sections: []
                });
            },

            submitForm() {
                this.eventHub.$emit('processing-start');
                this.form.put(route('game::marketing-resources.update-sections-translations', {elementType: this.elementType, language: this.translatedLanguage}))
                    .then(response => {
                        this.$bvModal.hide('sections-translations-modal');
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', t.__('Coś poszło nie tak. Sprawdź poprawność danych.'), 'error');
                    });
            }

        }

    }
</script>

<style scoped>



</style>
